export default "__VITE_ASSET__BRxzRx1z__"